import classnames from 'classnames';
import dict from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import { getProductName } from 'utilities/huggg';
import { interpolate, interpolateMany } from 'utilities/interpolate';
import styles from './title.module.scss';

const StashTitle = (props) => {
  const { huggg, isSuperhugggEmailClaim, isSuperhugggSMSClaim, view } = props;

  const title = huggg.isSuperhuggg
    ? isSuperhugggSMSClaim
      ? dict.stash.superhuggg.title.sms
      : dict.stash.superhuggg.title.email
    : dict.stash.huggg.title;

  const copy =
    view === 'confirm'
      ? !huggg.isSuperhuggg || !isSuperhugggEmailClaim
        ? interpolate(
            dict.stash.confirmationTitle.sms,
            '[br]',
            <br key={null} />,
          )
        : interpolate(
            dict.stash.confirmationTitle.email,
            '[br]',
            <br key={null} />,
          )
      : interpolateMany(title, [
          ['[br]', <br key={null} />],
          ['[product_name]', <>{getProductName(huggg)}</>],
        ]);

  return (
    <h3 className={classnames(styles.title, styles['title-redesign'])}>
      {copy}
    </h3>
  );
};

StashTitle.propTypes = {
  huggg: PropTypes.object.isRequired,
  isSuperhugggEmailClaim: PropTypes.bool,
  isSuperhugggSMSClaim: PropTypes.bool,
  view: PropTypes.string.isRequired,
};

export default StashTitle;
